import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import { format } from 'date-fns';
import Card from '../Card';
import Calendar from '../Calendar';
import FocusGroup from '../FocusGroup';
import Icon from '../Icon';
import Input from '../Input/Input';
import Popover from '../Popover';
import { generateId } from '../utils';

var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "calendar",
  color: "foregroundTertiary"
});

var DateField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DateField, _Component);

  function DateField() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "canClosePopover", true);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isPopoverOpen: _this.props.defaultOpen
    });

    _defineProperty(_assertThisInitialized(_this), "id", generateId('datefield'));

    _defineProperty(_assertThisInitialized(_this), "openPopover", function () {
      _this.setState({
        isPopoverOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePopover", function () {
      if (_this.canClosePopover) {
        _this.setState({
          isPopoverOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "togglePopover", function () {
      if (_this.state.isPopoverOpen) {
        _this.closePopover();
      } else {
        _this.openPopover();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateSelect", function (date) {
      var input = _this.inputWrapper.querySelector('input');

      if (input.focus) {
        input.focus();
      }

      if (_this.props.onChange) {
        _this.props.onChange(date);
      }

      _this.closePopover();
    });

    return _this;
  }

  var _proto = DateField.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        formatValue = _this$props.formatValue,
        defaultOpen = _this$props.defaultOpen,
        keepInView = _this$props.keepInView,
        lockScrollWhileOpen = _this$props.lockScrollWhileOpen,
        minDate = _this$props.minDate,
        maxDate = _this$props.maxDate,
        onChange = _this$props.onChange,
        placement = _this$props.placement,
        value = _this$props.value,
        popoverProps = _this$props.popoverProps,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["formatValue", "defaultOpen", "keepInView", "lockScrollWhileOpen", "minDate", "maxDate", "onChange", "placement", "value", "popoverProps"]);

    var isPopoverOpen = this.state.isPopoverOpen;
    return /*#__PURE__*/React.createElement(FocusGroup, {
      onBlur: this.closePopover
    }, function (_ref) {
      var requestBlur = _ref.requestBlur,
          setRef = _ref.setRef;
      return /*#__PURE__*/React.createElement(Popover, _extends({}, popoverProps, {
        ref: function ref(component) {
          _this2.popover = component;
        },
        innerRef: function innerRef(node) {
          setRef(_this2.id + "-popover")(node);
        },
        as: Card,
        tabIndex: -1,
        elevation: 2,
        onBlur: requestBlur,
        keepInView: keepInView,
        lockScrollWhileOpen: lockScrollWhileOpen,
        placement: placement,
        open: isPopoverOpen,
        onRequestClose: _this2.closePopover,
        anchorElement: /*#__PURE__*/React.createElement(Input, _extends({
          innerRef: function innerRef(node) {
            _this2.inputWrapper = node;
            setRef(_this2.id + "-input")(node);
          },
          readOnly: true,
          value: value ? format(value, formatValue) : '',
          renderRight: _ref2,
          onClick: _this2.togglePopover,
          onBlur: requestBlur,
          onKeyDown: function onKeyDown(event) {
            if (event.key === ' ') {
              event.preventDefault();

              _this2.togglePopover();
            }
          }
        }, restProps))
      }), /*#__PURE__*/React.createElement(Calendar, {
        size: "sm",
        initialDate: value,
        selected: value,
        minDate: minDate,
        maxDate: maxDate,
        onDateSelect: _this2.handleDateSelect
      }));
    });
  };

  return DateField;
}(Component);

_defineProperty(DateField, "defaultProps", {
  defaultOpen: false,
  lockScrollWhileOpen: true,
  formatValue: 'MMMM dd, yyyy'
});

export default DateField;